import { render, staticRenderFns } from "./ReorderBlock.vue?vue&type=template&id=45212cc0&"
import script from "./ReorderBlock.vue?vue&type=script&lang=js&"
export * from "./ReorderBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports